import { Utils } from '@/utils/Utils';
import { IStore } from '@/mainComponent/store/interfaces/IGame';

class BaseComponent {
  init() {
    if (!Utils.isInsertIntegration()) return;

    game.fsm.subscribe('promo', this.getFSMHandlers());
  }

  onLoadingComponentsResources() {}
  onIdleEnter() {}
  waitSpin() {}

  onSpinEnterSpin() {}
  onSpinEndSpin() {}

  onShowWinEnter() {}
  onShowWinAllLines() {}

  onCheckExit() {}

  getFSMHandlers(): any {
    return {
      LOADING: {
        loadComponentsResources: {
          on: this.onLoadingComponentsResources.bind(this)
        }
      },
      IDLE: {
        enter: {
          on: this.onIdleEnter.bind(this)
        },
        waitSpin: {
          on: this.waitSpin.bind(this)
        }
      },
      SPIN: {
        enter: {
          on: this.onSpinEnterSpin.bind(this)
        },
        endSpin: {
          on: this.onSpinEndSpin.bind(this)
        }
      },
      SHOW_WIN: {
        enter: {
          on: this.onShowWinEnter.bind(this)
        },
        showAllWins: {
          on: this.onShowWinAllLines.bind(this)
        }
      },
      CHECK: {
        exit: {
          on: this.onCheckExit.bind(this)
        }
      }
    };
  }

  get store(): IStore {
    return game.store;
  }
}

export { BaseComponent };
